"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//open layers
require("ol/ol.css");
var ol_1 = require("ol");
var layer_js_1 = require("ol/layer.js");
var Graticule_js_1 = __importDefault(require("ol/Graticule.js"));
var style_js_1 = require("ol/style.js");
var Draw_js_1 = __importDefault(require("ol/interaction/Draw.js"));
//sources
var OSM_1 = __importDefault(require("ol/source/OSM"));
//general
var proj_js_1 = require("ol/proj.js");
var harbour_js_1 = __importDefault(require("./../classes/harbour.js"));
var route_js_1 = __importDefault(require("./../classes/route.js"));
var helper_js_1 = require("./../classes/helper.js");
var sphere_1 = require("ol/sphere");
RouteMapDirective.$inject = ['$http', 'config', 'api'];
function RouteMapDirective($http, config, api) {
    return {
        restrict: 'E',
        template: require('./views/route-map.html'),
        scope: {
            aharbour: '=',
            dharbour: '=',
            roption: '=',
            route: '=',
            isnew: '=',
            atime: '=',
            dtime: '='
        },
        link: function (scope, el, attrs, ctrl) {
            var self = this;
            var routeLayer = new route_js_1.default();
            var harbourLayer = new harbour_js_1.default();
            var view = new ol_1.View({
                center: proj_js_1.fromLonLat([15.25, 38.15]),
                zoom: 5,
                minZoom: 5,
                maxZoom: 14,
                projection: 'EPSG:3857',
                enableRotation: false
            });
            var map = new ol_1.Map({
                target: angular.element(el[0].querySelector('.map-core'))[0],
                layers: [],
                loadTilesWhileAnimating: false,
                view: view
            });
            var baseLayer = new layer_js_1.Tile({
                preload: 4,
                source: new OSM_1.default({}),
            });
            map.addLayer(baseLayer);
            // Create the graticule component
            var graticule = new Graticule_js_1.default({
                // the style to use for the lines, optional.
                strokeStyle: new style_js_1.Stroke({
                    color: '#b8b8b8',
                    width: 2,
                    lineDash: [0.5, 4]
                }),
                showLabels: true
            });
            graticule.setMap(map);
            map.addLayer(harbourLayer.get());
            map.addLayer(routeLayer.get());
            var afeature = harbourLayer.addFeature();
            var dfeature = harbourLayer.addFeature();
            scope.$watch('aharbour', function (newval, oldval) {
                if (!_.isEmpty(newval)) {
                    harbourLayer.setPosition(afeature, proj_js_1.fromLonLat([parseFloat(newval.lon), parseFloat(newval.lat)]));
                }
                else {
                    harbourLayer.setPosition(afeature, proj_js_1.fromLonLat([0, 0]));
                }
                if (!_.isEmpty(newval) && !_.isEmpty(oldval) && newval !== oldval) {
                    routeLayer.getSource().clear();
                }
                if (!_.isEmpty(oldval) && _.isEmpty(newval)) {
                    routeLayer.getSource().clear();
                }
                if (!_.isEmpty(scope.aharbour) && !_.isEmpty(scope.dharbour)) {
                    fitView();
                }
            });
            scope.$watch('dharbour', function (newval, oldval) {
                if (!_.isEmpty(newval)) {
                    harbourLayer.setPosition(dfeature, proj_js_1.fromLonLat([parseFloat(newval.lon), parseFloat(newval.lat)]));
                }
                else {
                    harbourLayer.setPosition(dfeature, proj_js_1.fromLonLat([0, 0]));
                }
                if (!_.isEmpty(newval) && !_.isEmpty(oldval) && newval !== oldval) {
                    routeLayer.getSource().clear();
                }
                if (!_.isEmpty(oldval) && _.isEmpty(newval)) {
                    routeLayer.getSource().clear();
                }
                if (!_.isEmpty(scope.aharbour) && !_.isEmpty(scope.dharbour)) {
                    fitView();
                }
            });
            function fitView() {
                var extent = harbourLayer.getExtent();
                map.getView().fit(extent, { padding: [50, 480, 100, 50] });
            }
            //Draw route
            var draw_interaction = new Draw_js_1.default({
                source: routeLayer.getSource(),
                type: 'LineString'
            });
            scope.$watchGroup(['route', 'roption'], function (nval, oval) {
                if (nval[0] === null && nval[1] === 2) {
                    map.addInteraction(draw_interaction);
                }
                if (oval[0] === null && nval[0] !== null) {
                    map.removeInteraction(draw_interaction);
                }
                if (nval[0] === null && nval[1] === 1) {
                    map.removeInteraction(draw_interaction);
                }
                if (nval[0] === null && !_.isEmpty(oval)) {
                    routeLayer.getSource().clear();
                }
                if (_.isEmpty(oval[0]) && !_.isEmpty(nval[0]) && !scope.isnew) {
                    var points = [];
                    _.each(scope.route, function (val, idx) {
                        var feature = routeLayer.addFeature({ id: idx + 1 });
                        routeLayer.setPosition(feature, proj_js_1.fromLonLat([val.lon, val.lat]));
                        points.push(proj_js_1.fromLonLat([val.lon, val.lat]));
                    });
                    routeLayer.drawRoute(points);
                }
                if (_.isEmpty(oval[0]) && !_.isEmpty(nval[0]) && scope.isnew && nval[1] === 1) {
                    var points = [];
                    _.each(scope.route, function (val, idx) {
                        var feature = routeLayer.addFeature({ id: idx + 1 });
                        routeLayer.setPosition(feature, proj_js_1.fromLonLat([val.lon, val.lat]));
                        points.push(proj_js_1.fromLonLat([val.lon, val.lat]));
                    });
                    routeLayer.drawRoute(points);
                }
            });
            draw_interaction.on('drawend', function (evt) {
                var coordinates = evt.feature.getGeometry().getCoordinates();
                _.each(coordinates, function (val, idx) {
                    var feature = routeLayer.addFeature({ id: idx + 1 });
                    routeLayer.setPosition(feature, val);
                });
                var waypoints = _.map(coordinates, function (c) {
                    var c = proj_js_1.toLonLat(c);
                    return {
                        lon: c[0],
                        lat: c[1]
                    };
                });
                scope.route = buildRouteDetails(waypoints);
                scope.$apply();
            });
            //requires at least 3 points
            var buildRouteDetails = function (points) {
                var distance = 0; //in km
                var tripTime = moment.utc(scope.atime).diff(moment.utc(scope.dtime), 'minutes') / 60;
                for (var i = 0; i < points.length; i++) {
                    points[i].wpt = i + 1;
                    points[i].distance = (i === 0) ? 0 : sphere_1.getDistance([points[i].lon, points[i].lat], [points[i - 1].lon, points[i - 1].lat]) / 1000;
                    distance += points[i].distance;
                    points[i].bearing = (i == (points.length - 1)) ? points[i - 1].bearing : helper_js_1.getBearing(points[i].lat, points[i].lon, points[i + 1].lat, points[i + 1].lon);
                }
                var meanSpeed = distance / tripTime;
                var semiSpeed = meanSpeed / 2;
                // let semiSpeedDistanceF = _.min([15, points[1].distance]);
                // let semiSpeedDistanceL = _.min([15, points[points.length-1].distance]);
                // let semiSpeedDistance = semiSpeedDistanceF + semiSpeedDistanceL;
                var semiSpeedDistance = points[1].distance + points[points.length - 1].distance;
                meanSpeed = (distance - semiSpeedDistance) / (tripTime - (semiSpeedDistance / semiSpeed));
                for (var i = 0; i < points.length; i++) {
                    if (i === 0) {
                        points[i].speed = 0;
                        points[i].eta = moment.utc(scope.dtime);
                    }
                    else if (i === points.length - 1) {
                        points[i].speed = 0;
                        points[i].eta = moment.utc(scope.atime);
                    }
                    else {
                        var time = void 0;
                        if (i === 1) {
                            // if (points[1].distance >= 15) {
                            // 	time = 15/semiSpeed + (points[1].distance-15)/meanSpeed ;
                            // } else {
                            time = points[1].distance / semiSpeed;
                            // }
                        }
                        else {
                            time = points[i].distance / meanSpeed;
                        }
                        time = Math.round(time * 3600);
                        points[i].eta = points[i - 1].eta.clone().add(time, 'seconds');
                        points[i].speed = meanSpeed;
                    }
                    points[i].distance = Math.round(points[i].distance * 100000) / 100; //km to m, + rounded
                    points[i].speed = Math.round((points[i].speed / 3.6) * 1000) / 1000; //km/h to m/s, + rounded
                }
                return points;
            };
            document.addEventListener('keydown', function (e) {
                if (e.which == 27) {
                    draw_interaction.removeLastPoint();
                    var feature_list = routeLayer.getSource().getFeatures();
                    if (feature_list.length) {
                        routeLayer.getSource().clear();
                        scope.route = null;
                        scope.$apply();
                    }
                }
            });
        }
    };
}
exports.RouteMapDirective = RouteMapDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/directives/RouteMapDirective.js
// module id = 567
// module chunks = 0